<div class="wrapper">
  <p (click)="trigger()">
    <strong [innerHTML]="header"></strong>
    <span [ngClass]="{active:toggle}">
            {{disable ? 'Coming Soon' : toggle ? 'Collapse' : 'Expand' }}
      <svg *ngIf="!disable" [style.transform]="toggle ? 'rotate(180deg)':'rotate(0deg)' "
           xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
           stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5"/>
            </svg>
        </span>
  </p>
  <div class="content" [ngClass]="{active:toggle}">
    <ng-content></ng-content>
  </div>
</div>
